export default "__VITE_ASSET__CxFkdpCU__"